export default {
  "Arabic": {
    "male": [{
      "provider": "google",
      "name": "ar-XA-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-XA"
    }],
    "female": [{
      "provider": "google",
      "name": "ar-XA-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Wavenet-D",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }, {
      "provider": "google",
      "name": "ar-XA-Standard-D",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-XA"
    }]
  },
  "Arabic - Gulf": {
    "male": [{
      "provider": "amazon",
      "name": "Zayd",
      "styles": ["default"],
      "gender": "male",
      "language": "ar-AE"
    }],
    "female": [{
      "provider": "amazon",
      "name": "Hala",
      "styles": ["default"],
      "gender": "female",
      "language": "ar-AE"
    }]
  },
  "Bengali": {
    "male": [{
      "provider": "google",
      "name": "bn-IN-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "bn-IN"
    }],
    "female": [{
      "provider": "google",
      "name": "bn-IN-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }, {
      "provider": "google",
      "name": "bn-IN-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "bn-IN"
    }]
  },
  "Catalan": {
    "male": [],
    "female": [{
      "provider": "amazon",
      "name": "Arlet",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "ca-ES"
    }, {
      "provider": "google",
      "name": "ca-ES-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ca-ES"
    }, {
      "provider": "google",
      "name": "ca-ES-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "ca-ES"
    }]
  },
  "Czech": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "cs-CZ-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "cs-CZ"
    }, {
      "provider": "google",
      "name": "cs-CZ-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "cs-CZ"
    }, {
      "provider": "google",
      "name": "cs-CZ-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "cs-CZ"
    }, {
      "provider": "google",
      "name": "cs-CZ-Wavenet-B",
      "styles": ["default"],
      "gender": "female",
      "language": "cs-CZ"
    }]
  },
  "Danish": {
    "male": [{
      "provider": "google",
      "name": "da-DK-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "da-DK"
    }, {
      "provider": "google",
      "name": "da-DK-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "da-DK"
    }, {
      "provider": "google",
      "name": "da-DK-Standard-G",
      "styles": ["default"],
      "gender": "male",
      "language": "da-DK"
    }, {
      "provider": "google",
      "name": "da-DK-Wavenet-G",
      "styles": ["default"],
      "gender": "male",
      "language": "da-DK"
    }],
    "female": [{
      "provider": "google",
      "name": "da-DK-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "da-DK"
    }, {
      "provider": "google",
      "name": "da-DK-Wavenet-D",
      "styles": ["default"],
      "gender": "female",
      "language": "da-DK"
    }, {
      "provider": "google",
      "name": "da-DK-Wavenet-E",
      "styles": ["default"],
      "gender": "female",
      "language": "da-DK"
    }, {
      "provider": "google",
      "name": "da-DK-Neural2-F",
      "styles": ["default"],
      "gender": "female",
      "language": "da-DK"
    }, {
      "provider": "google",
      "name": "da-DK-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "da-DK"
    }, {
      "provider": "google",
      "name": "da-DK-Standard-D",
      "styles": ["default"],
      "gender": "female",
      "language": "da-DK"
    }, {
      "provider": "google",
      "name": "da-DK-Standard-E",
      "styles": ["default"],
      "gender": "female",
      "language": "da-DK"
    }, {
      "provider": "google",
      "name": "da-DK-Standard-F",
      "styles": ["default"],
      "gender": "female",
      "language": "da-DK"
    }, {
      "provider": "google",
      "name": "da-DK-Wavenet-F",
      "styles": ["default"],
      "gender": "female",
      "language": "da-DK"
    }]
  },
  "Dutch - Belgium": {
    "male": [{
      "provider": "google",
      "name": "nl-BE-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-BE"
    }],
    "female": [{
      "provider": "google",
      "name": "nl-BE-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "amazon",
      "name": "Lisa",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }, {
      "provider": "google",
      "name": "nl-BE-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-BE"
    }]
  },
  "Dutch - Netherlands": {
    "male": [{
      "provider": "google",
      "name": "nl-NL-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Standard-G",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Wavenet-G",
      "styles": ["default"],
      "gender": "male",
      "language": "nl-NL"
    }],
    "female": [{
      "provider": "google",
      "name": "nl-NL-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Wavenet-D",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nnl-NL-Wavenet-E",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "amazon",
      "name": "Laura",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Standard-D",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Standard-E",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Standard-F",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Wavenet-E",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }, {
      "provider": "google",
      "name": "nl-NL-Wavenet-F",
      "styles": ["default"],
      "gender": "female",
      "language": "nl-NL"
    }]
  },
  "ElevenLabs": {
    "male": [],
    "female": []
  },
  "English - Australia": {
    "male": [{
      "provider": "deepgram",
      "name": "aura-2-hyperion-en",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-DarrenNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-DuncanNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-KenNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-NeilNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-TimNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-WilliamNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp-HD-D",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Neural2-B",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Neural2-D",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-News-G",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Polyglot-1",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "en-AU"
    }],
    "female": [{
      provider: "deepgram",
      name: "aura-2-theia-en",
      styles: ["default"],
      gender: "female",
      language: "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "amazon",
      "name": "Olivia",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-AnnetteNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-CarlyNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-ElsieNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-FreyaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-JoanneNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-KimNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-NatashaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "microsoft",
      "name": "en-AU-TinaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp-HD-F",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp-HD-O",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Neural2-A",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Neural2-C",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-News-E",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-News-F",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }, {
      "provider": "google",
      "name": "en-AU-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "en-AU"
    }]
  },
  "English - Filipino": {
    "male": [],
    "female": [{
      provider: "deepgram",
      name: "aura-2-amalthea-en",
      styles: ["default"],
      gender: "female",
      language: "en-PH"
    }]
  },
  "English - India": {
    "male": [{
      "provider": "google",
      "name": "en-IN-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp-HD-D",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Neural2-B",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Neural2-C",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Standard-F",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Wavenet-F",
      "styles": ["default"],
      "gender": "male",
      "language": "en-IN"
    }],
    "female": [{
      "provider": "google",
      "name": "en-IN-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Wavenet-D",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp-HD-F",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp-HD-O",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Neural2-A",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Neural2-D",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Standard-D",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Standard-E",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }, {
      "provider": "google",
      "name": "en-IN-Wavenet-E",
      "styles": ["default"],
      "gender": "female",
      "language": "en-IN"
    }]
  },
  "English - New Zealand": {
    "male": [],
    "female": [{
      "provider": "amazon",
      "name": "Aria",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "en-NZ"
    }]
  },
  "English - South African": {
    "male": [],
    "female": [{
      "provider": "amazon",
      "name": "Ayanda",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "en-AF"
    }]
  },
  "English - UK": {
    "male": [{
      "provider": "deepgram",
      "name": "aura-2-draco-en",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Studio-B",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "amazon",
      "name": "Brian",
      "styles": ["default"],
      "ntts": true,
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-AlfieNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-ElliotNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-EthanNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-NoahNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-OliverNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-RyanNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-ThomasNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp-HD-D",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Neural2-B",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Neural2-D",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Neural2-O",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-News-J",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-News-K",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-News-L",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-News-M",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Standard-O",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Wavenet-O",
      "styles": ["default"],
      "gender": "male",
      "language": "en-GB"
    }],
    "female": [{
      provider: "deepgram",
      name: "aura-2-pandora-en",
      styles: ["default"],
      gender: "female",
      language: "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Studio-C",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Wavenet-F",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "amazon",
      "name": "Amy",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "amazon",
      "name": "Emma",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-AbbiNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-BellaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-HollieNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-LibbyNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-MaisieNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-OliviaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "microsoft",
      "name": "en-GB-SoniaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp-HD-F",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp-HD-O",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Neural2-A",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Neural2-C",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Neural2-F",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Neural2-N",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-News-G",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-News-H",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-News-I",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Standard-F",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Standard-N",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }, {
      "provider": "google",
      "name": "en-GB-Wavenet-N",
      "styles": ["default"],
      "gender": "female",
      "language": "en-GB"
    }]
  },
  "English - US": {
    "male": [{
      "provider": "google",
      "name": "en-US-Studio-Q",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Neural2-A",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Neural2-D",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Neural2-I",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Neural2-J",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Wavenet-A",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Wavenet-I",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Wavenet-J",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "amazon",
      "name": "Joey",
      "styles": ["default"],
      "ntts": true,
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "amazon",
      "name": "Justin",
      "styles": ["default"],
      "ntts": true,
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "amazon",
      "name": "Kevin",
      "styles": ["default"],
      "ntts": true,
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "amazon",
      "name": "Matthew",
      "styles": ["default"],
      "ntts": true,
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "amazon",
      "name": "Gregory",
      "styles": ["default"],
      "ntts": true,
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-AndrewNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-BrianNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-DavisNeural",
      "styles": ["default", "angry", "chat", "cheerful", "excited", "friendly", "hopeful", "sad", "shouting", "terrified", "unfriendly", "whispering"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-ChristopherNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-EricNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-GuyNeural",
      "styles": ["default", "angry", "cheerful", "excited", "friendly", "hopeful", "newscast", "sad", "shouting", "terrified", "unfriendly", "whispering"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-JasonNeural",
      "styles": ["default", "angry", "cheerful", "excited", "friendly", "hopeful", "sad", "shouting", "terrified", "unfriendly", "whispering"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-TonyNeural",
      "styles": ["default", "angry", "cheerful", "excited", "friendly", "hopeful", "sad", "shouting", "terrified", "unfriendly", "whispering"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-AIGenerate1Neural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-BrandonNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Casual-K",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp-HD-D",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-News-N",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Polyglot-1",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Standard-A",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Standard-I",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Standard-J",
      "styles": ["default"],
      "gender": "male",
      "language": "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-apollo-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-arcas-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-aries-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-atlas-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-hermes-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-jupiter-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-mars-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-neptune-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-odysseus-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-orion-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-orpheus-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-pluto-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-saturn-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-zeus-en",
      styles: ["default"],
      gender: "male",
      language: "en-US"
    }],
    "female": [{
      provider: "deepgram",
      name: "aura-2-andromeda-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-asteria-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-athena-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-aurora-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-callista-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-cora-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-cordelia-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-delia-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-electra-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-harmonia-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-helena-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-hera-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-iris-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-janus-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-juno-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-luna-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-minerva-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-ophelia-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-phoebe-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-selene-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-thalia-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      provider: "deepgram",
      name: "aura-2-vesta-en",
      styles: ["default"],
      gender: "female",
      language: "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Studio-O",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Neural2-C",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Neural2-D",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Neural2-E",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Neural2-F",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Neural2-H",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Wavenet-E",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Wavenet-F",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Wavenet-G",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Wavenet-H",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "amazon",
      "name": "Ruth",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "amazon",
      "name": "Danielle",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "amazon",
      "name": "Ivy",
      "styles": ["default"],
      "ntts": true,
      "child": true,
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "amazon",
      "name": "Joanna",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "amazon",
      "name": "Kendra",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "amazon",
      "name": "Kimberly",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "amazon",
      "name": "Salli",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-AIGenerate2Neural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-EmmaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-AriaNeural",
      "styles": ["default", "angry", "chat", "cheerful", "customerservice", "empathetic", "excited", "friendly", "hopeful", "narration-professional", "newscast-casual", "newscast-formal", "sad", "shouting", "terrified", "unfriendly", "whispering"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-JaneNeural",
      "styles": ["default", "angry", "cheerful", "excited", "friendly", "hopeful", "sad", "shouting", "terrified", "unfriendly", "whispering"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-JennyNeural",
      "styles": ["default", "angry", "assistant", "chat", "cheerful", "customerservice", "excited", "friendly", "hopeful", "newscast", "sad", "shouting", "terrified", "unfriendly", "whispering"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-NancyNeural",
      "styles": ["default", "angry", "cheerful", "excited", "friendly", "hopeful", "sad", "shouting", "terrified", "unfriendly", "whispering"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "microsoft",
      "name": "en-US-SaraNeural",
      "styles": ["default", "angry", "cheerful", "excited", "friendly", "hopeful", "sad", "shouting", "terrified", "unfriendly", "whispering"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp-HD-F",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp-HD-O",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Neural2-G",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-News-K",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-News-L",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Standard-E",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Standard-F",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Standard-G",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }, {
      "provider": "google",
      "name": "en-US-Standard-H",
      "styles": ["default"],
      "gender": "female",
      "language": "en-US"
    }]
  },
  "Filipino": {
    "male": [{
      "provider": "google",
      "name": "fil-PH-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "fil-PH"
    }, {
      "provider": "google",
      "name": "fil-PH-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "fil-PH"
    }, {
      "provider": "google",
      "name": "fil-PH-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "fil-PH"
    }, {
      "provider": "google",
      "name": "fil-PH-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "fil-PH"
    }, {
      "provider": "google",
      "name": "fil-ph-Neural2-D",
      "styles": ["default"],
      "gender": "male",
      "language": "fil-PH"
    }],
    "female": [{
      "provider": "google",
      "name": "fil-PH-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "fil-PH"
    }, {
      "provider": "google",
      "name": "fil-PH-Wavenet-B",
      "styles": ["default"],
      "gender": "female",
      "language": "fil-PH"
    }, {
      "provider": "google",
      "name": "fil-PH-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "fil-PH"
    }, {
      "provider": "google",
      "name": "fil-PH-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "fil-PH"
    }, {
      "provider": "google",
      "name": "fil-ph-Neural2-A",
      "styles": ["default"],
      "gender": "female",
      "language": "fil-PH"
    }]
  },
  "Finnish": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "fi-FI-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "fi-FI"
    }, {
      "provider": "google",
      "name": "fi-FI-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "fi-FI"
    }, {
      "provider": "google",
      "name": "fi-FI-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "fi-FI"
    }, {
      "provider": "google",
      "name": "fi-FI-Wavenet-B",
      "styles": ["default"],
      "gender": "female",
      "language": "fi-FI"
    }]
  },
  "French - Canada": {
    "male": [{
      "provider": "google",
      "name": "fr-CA-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "microsoft",
      "name": "fr-CA-JeanNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "microsoft",
      "name": "fr-CA-AntoineNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "microsoft",
      "name": "fr-CA-ThierryNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp-HD-D",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Neural2-B",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Neural2-D",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-CA"
    }],
    "female": [{
      "provider": "google",
      "name": "fr-CA-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "amazon",
      "name": "Gabrielle",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "microsoft",
      "name": "fr-CA-SylvieNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp-HD-F",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp-HD-O",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Neural2-A",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Neural2-C",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }, {
      "provider": "google",
      "name": "fr-CA-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-CA"
    }]
  },
  "French - France": {
    "male": [{
      "provider": "google",
      "name": "fr-FR-Studio-D",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-AlainNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-ClaudeNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-HenriNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-JeromeNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-MauriceNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-YvesNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp-HD-D",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Neural2-G",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Polyglot-1",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Standard-G",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Wavenet-G",
      "styles": ["default"],
      "gender": "male",
      "language": "fr-FR"
    }],
    "female": [{
      "provider": "google",
      "name": "fr-FR-Studio-A",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Wavenet-E",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "amazon",
      "name": "Lea",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-BrigitteNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-CelesteNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-CoralieNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-DeniseNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-EloiseNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-JacquelineNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-JosephineNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-YvetteNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "microsoft",
      "name": "fr-FR-VivienneNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp-HD-F",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp-HD-O",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Neural2-F",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Standard-E",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Standard-F",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }, {
      "provider": "google",
      "name": "fr-FR-Wavenet-F",
      "styles": ["default"],
      "gender": "female",
      "language": "fr-FR"
    }]
  },
  "German": {
    "male": [{
      "provider": "google",
      "name": "de-DE-Studio-B",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Wavenet-E",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-BerndNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-ChristophNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-ConradNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-KasperNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-KillianNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-KlausNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-RalfNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "amazon",
      "name": "Daniel",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp-HD-D",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Neural2-H",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Polyglot-1",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Standard-E",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Standard-H",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Wavenet-H",
      "styles": ["default"],
      "gender": "male",
      "language": "de-DE"
    }],
    "female": [{
      "provider": "google",
      "name": "de-DE-Studio-C",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Wavenet-F",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "amazon",
      "name": "Vicki",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-SeraphinaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-AmalaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-ElkeNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-GiselaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-KatjaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-KlarissaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-LouisaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-MajaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "microsoft",
      "name": "de-DE-TanjaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "amazon",
      "name": "Vicki",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp-HD-F",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp-HD-O",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Neural2-G",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Standard-F",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Standard-G",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }, {
      "provider": "google",
      "name": "de-DE-Wavenet-G",
      "styles": ["default"],
      "gender": "female",
      "language": "de-DE"
    }]
  },
  "German - Austrian": {
    "male": [],
    "female": [{
      "provider": "amazon",
      "name": "Hannah",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "de-AT"
    }]
  },
  "Greek": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "el-GR-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "el-GR"
    }, {
      "provider": "google",
      "name": "el-GR-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "el-GR"
    }, {
      "provider": "google",
      "name": "el-GR-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "el-GR"
    }, {
      "provider": "google",
      "name": "el-GR-Wavenet-B",
      "styles": ["default"],
      "gender": "female",
      "language": "el-GR"
    }]
  },
  "Gujarati": {
    "male": [{
      "provider": "google",
      "name": "gu-IN-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "gu-IN"
    }],
    "female": [{
      "provider": "google",
      "name": "gu-IN-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }, {
      "provider": "google",
      "name": "gu-IN-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "gu-IN"
    }]
  },
  "Hindi": {
    "male": [{
      "provider": "google",
      "name": "hi-IN-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Neural2-B",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Neural2-C",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Standard-F",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Wavenet-F",
      "styles": ["default"],
      "gender": "male",
      "language": "hi-IN"
    }],
    "female": [{
      "provider": "google",
      "name": "hi-IN-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Wavenet-D",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Neural2-A",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Neural2-D",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Standard-D",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Standard-E",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }, {
      "provider": "google",
      "name": "hi-IN-Wavenet-E",
      "styles": ["default"],
      "gender": "female",
      "language": "hi-IN"
    }]
  },
  "Hungarian": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "hu-HU-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "hu-HU"
    }, {
      "provider": "google",
      "name": "hu-HU-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "hu-HU"
    }, {
      "provider": "google",
      "name": "hu-HU-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "hu-HU"
    }]
  },
  "Indonesian": {
    "male": [{
      "provider": "google",
      "name": "id-ID-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "id-ID"
    }],
    "female": [{
      "provider": "google",
      "name": "id-ID-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Wavenet-D",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }, {
      "provider": "google",
      "name": "id-ID-Standard-D",
      "styles": ["default"],
      "gender": "female",
      "language": "id-ID"
    }]
  },
  "Italian": {
    "male": [{
      "provider": "google",
      "name": "it-IT-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-GiuseppeNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-BenignoNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-CalimeroNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-CataldoNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-DiegoNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-GianniNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-LisandroNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-RinaldoNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "amazon",
      "name": "Adriano",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp-HD-D",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Neural2-F",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Standard-F",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Wavenet-F",
      "styles": ["default"],
      "gender": "male",
      "language": "it-IT"
    }],
    "female": [{
      "provider": "google",
      "name": "it-IT-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Wavenet-B",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "amazon",
      "name": "Bianca",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-ElsaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-FabiolaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-FiammaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-ImeldaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-IrmaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-IsabellaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-PalmiraNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "microsoft",
      "name": "it-IT-PierinaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp-HD-F",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp-HD-O",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Neural2-A",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Neural2-E",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Standard-E",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }, {
      "provider": "google",
      "name": "it-IT-Wavenet-E",
      "styles": ["default"],
      "gender": "female",
      "language": "it-IT"
    }]
  },
  "Japanese": {
    "male": [{
      "provider": "google",
      "name": "ja-JP-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "amazon",
      "name": "Takumi",
      "styles": ["default"],
      "ntts": true,
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Neural2-C",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Neural2-D",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "ja-JP"
    }],
    "female": [{
      "provider": "google",
      "name": "ja-JP-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Wavenet-B",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "microsoft",
      "name": "ja-JP-NanamiNeural",
      "styles": ["default", "chat", "cheerful", "customerservice"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Neural2-B",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }, {
      "provider": "google",
      "name": "ja-JP-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "ja-JP"
    }]
  },
  "Kannada": {
    "male": [{
      "provider": "google",
      "name": "kn-IN-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "kn-IN"
    }],
    "female": [{
      "provider": "google",
      "name": "kn-IN-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }, {
      "provider": "google",
      "name": "kn-IN-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "kn-IN"
    }]
  },
  "Korean": {
    "male": [{
      "provider": "google",
      "name": "ko-KR-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Wavenet-D",
      "styles": ["default"],
      "language": "ko-KR"
    }, {
      "provider": "microsoft",
      "name": "ko-KR-HyunsuNeural",
      "styles": ["default"],
      "language": "ko-KR"
    }, {
      "provider": "microsoft",
      "name": "ko-KR-InJoonNeural",
      "styles": ["default"],
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Neural2-C",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "ko-KR"
    }],
    "female": [{
      "provider": "google",
      "name": "ko-KR-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Wavenet-B",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "amazon",
      "name": "Seoyeon",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Neural2-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Neural2-B",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }, {
      "provider": "google",
      "name": "ko-KR-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "ko-KR"
    }]
  },
  "Malay": {
    "male": [{
      "provider": "google",
      "name": "ms-MY-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "ms-MY"
    }, {
      "provider": "google",
      "name": "ms-MY-Wavenet-D",
      "styles": ["default"],
      "language": "ms-MY"
    }, {
      "provider": "google",
      "name": "ms-MY-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "ms-MY"
    }, {
      "provider": "google",
      "name": "ms-MY-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "ms-MY"
    }],
    "female": [{
      "provider": "google",
      "name": "ms-MY-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ms-MY"
    }, {
      "provider": "google",
      "name": "ms-MY-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "ms-MY"
    }, {
      "provider": "google",
      "name": "ms-MY-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ms-MY"
    }, {
      "provider": "google",
      "name": "ms-MY-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "ms-MY"
    }]
  },
  "Malayalam": {
    "male": [{
      "provider": "google",
      "name": "ml-IN-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "ml-IN"
    }],
    "female": [{
      "provider": "google",
      "name": "ml-IN-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }, {
      "provider": "google",
      "name": "ml-IN-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "ml-IN"
    }]
  },
  "Mandarin Chinese": {
    "male": [{
      "provider": "google",
      "name": "cmn-CN-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-TW-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-TW-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-TW-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-TW"
    }, {
      "provider": "google",
      "name": "cmn-TW-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "cmn-TW"
    }],
    "female": [{
      "provider": "google",
      "name": "cmn-CN-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Wavenet-D",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-TW-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "microsoft",
      "name": "zh-CN-YunjieNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "microsoft",
      "name": "zh-CN-XiaoxiaoNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-CN-Standard-D",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-CN"
    }, {
      "provider": "google",
      "name": "cmn-TW-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "cmn-TW"
    }]
  },
  "Norwegian": {
    "male": [{
      "provider": "google",
      "name": "nb-NO-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "nb-NO"
    }, {
      "provider": "google",
      "name": "nb-NO-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "nb-NO"
    }, {
      "provider": "google",
      "name": "nb-NO-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "nb-NO"
    }, {
      "provider": "google",
      "name": "nb-NO-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "nb-NO"
    }, {
      "provider": "google",
      "name": "nb-NO-Standard-G",
      "styles": ["default"],
      "gender": "male",
      "language": "nb-NO"
    }, {
      "provider": "google",
      "name": "nb-NO-Wavenet-G",
      "styles": ["default"],
      "gender": "male",
      "language": "nb-NO"
    }],
    "female": [{
      "provider": "google",
      "name": "nb-NO-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "nb-NO"
    }, {
      "provider": "google",
      "name": "nb-NO-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "nb-NO"
    }, {
      "provider": "google",
      "name": "nb-no-Wavenet-E",
      "styles": ["default"],
      "gender": "female",
      "language": "nb-NO"
    }, {
      "provider": "google",
      "name": "nb-NO-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "nb-NO"
    }, {
      "provider": "google",
      "name": "nb-NO-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "nb-NO"
    }, {
      "provider": "google",
      "name": "nb-NO-Standard-E",
      "styles": ["default"],
      "gender": "female",
      "language": "nb-NO"
    }, {
      "provider": "google",
      "name": "nb-NO-Standard-F",
      "styles": ["default"],
      "gender": "female",
      "language": "nb-NO"
    }, {
      "provider": "google",
      "name": "nb-NO-Wavenet-E",
      "styles": ["default"],
      "gender": "female",
      "language": "nb-NO"
    }, {
      "provider": "google",
      "name": "nb-NO-Wavenet-F",
      "styles": ["default"],
      "gender": "female",
      "language": "nb-NO"
    }]
  },
  "Polish": {
    "male": [{
      "provider": "google",
      "name": "pl-PL-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Standard-G",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Wavenet-G",
      "styles": ["default"],
      "gender": "male",
      "language": "pl-PL"
    }],
    "female": [{
      "provider": "google",
      "name": "pl-PL-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Wavenet-D",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Wavenet-E",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Standard-D",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Standard-E",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Standard-F",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }, {
      "provider": "google",
      "name": "pl-PL-Wavenet-F",
      "styles": ["default"],
      "gender": "female",
      "language": "pl-PL"
    }]
  },
  "Portuguese - Brazil": {
    "male": [{
      "provider": "google",
      "name": "pt-BR-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Neural2-B",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Standard-E",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Wavenet-E",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-BR"
    }],
    "female": [{
      "provider": "google",
      "name": "pt-BR-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "amazon",
      "name": "Camila",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "amazon",
      "name": "Victoria",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "microsoft",
      "name": "pt-BR-ThalitaNeural",
      "styles": ["default", "calm"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "microsoft",
      "name": "pt-BR-FranciscaNeural",
      "styles": ["default", "calm"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Neural2-A",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Neural2-C",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Standard-D",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }, {
      "provider": "google",
      "name": "pt-BR-Wavenet-D",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-BR"
    }]
  },
  "Portuguese - Portugal": {
    "male": [{
      "provider": "google",
      "name": "pt-PT-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-PT"
    }, {
      "provider": "google",
      "name": "pt-PT-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-PT"
    }, {
      "provider": "google",
      "name": "pt-PT-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-PT"
    }, {
      "provider": "google",
      "name": "pt-PT-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-PT"
    }, {
      "provider": "google",
      "name": "pt-PT-Standard-F",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-PT"
    }, {
      "provider": "google",
      "name": "pt-PT-Wavenet-F",
      "styles": ["default"],
      "gender": "male",
      "language": "pt-PT"
    }],
    "female": [{
      "provider": "google",
      "name": "pt-PT-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-PT"
    }, {
      "provider": "google",
      "name": "pt-PT-Wavenet-D",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-PT"
    }, {
      "provider": "amazon",
      "name": "Ines",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "pt-PT"
    }, {
      "provider": "google",
      "name": "pt-PT-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-PT"
    }, {
      "provider": "google",
      "name": "pt-PT-Standard-D",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-PT"
    }, {
      "provider": "google",
      "name": "pt-PT-Standard-E",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-PT"
    }, {
      "provider": "google",
      "name": "pt-PT-Wavenet-E",
      "styles": ["default"],
      "gender": "female",
      "language": "pt-PT"
    }]
  },
  "Punjabi": {
    "male": [{
      "provider": "google",
      "name": "pa-IN-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "pa-IN"
    }, {
      "provider": "google",
      "name": "pa-IN-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "pa-IN"
    }, {
      "provider": "google",
      "name": "pa-IN-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "pa-IN"
    }, {
      "provider": "google",
      "name": "pa-IN-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "pa-IN"
    }],
    "female": [{
      "provider": "google",
      "name": "pa-IN-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "pa-IN"
    }, {
      "provider": "google",
      "name": "pa-IN-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "pa-IN"
    }, {
      "provider": "google",
      "name": "pa-IN-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "pa-IN"
    }, {
      "provider": "google",
      "name": "pa-IN-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "pa-IN"
    }]
  },
  "Romanian": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "ro-RO-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ro-RO"
    }, {
      "provider": "google",
      "name": "ro-RO-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ro-RO"
    }, {
      "provider": "google",
      "name": "ro-RO-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "ro-RO"
    }, {
      "provider": "google",
      "name": "ro-RO-Wavenet-B",
      "styles": ["default"],
      "gender": "female",
      "language": "ro-RO"
    }]
  },
  "Russian": {
    "male": [{
      "provider": "google",
      "name": "ru-RU-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "ru-RU"
    }],
    "female": [{
      "provider": "google",
      "name": "ru-RU-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Wavenet-E",
      "styles": ["default"],
      "gender": "female",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "ru-RU"
    }, {
      "provider": "google",
      "name": "ru-RU-Standard-E",
      "styles": ["default"],
      "gender": "female",
      "language": "ru-RU"
    }]
  },
  "Slovak": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "sk-SK-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "sk-SK"
    }, {
      "provider": "google",
      "name": "sk-SK-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "sk-SK"
    }, {
      "provider": "google",
      "name": "sk-SK-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "sk-SK"
    }, {
      "provider": "google",
      "name": "sk-SK-Wavenet-B",
      "styles": ["default"],
      "gender": "female",
      "language": "sk-SK"
    }]
  },
  "Spanish - Spain": {
    "male": [{
      "provider": "google",
      "name": "es-ES-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-AlvaroNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-ArnauNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-DarioNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-EliasNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-NilNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-SaulNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-TeoNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "amazon",
      "name": "Sergio",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp-HD-D",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Neural2-F",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Neural2-G",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Polyglot-1",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Standard-E",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Standard-G",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Studio-F",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Wavenet-E",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Wavenet-G",
      "styles": ["default"],
      "gender": "male",
      "language": "es-ES"
    }],
    "female": [{
      "provider": "google",
      "name": "es-ES-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Wavenet-D",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "amazon",
      "name": "Lucia",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-XimenaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-AbrilNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-ElviraNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-EstrellaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-IreneNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-LaiaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-LiaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-TrianaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "microsoft",
      "name": "es-ES-VeraNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp-HD-F",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp-HD-O",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Neural2-A",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Neural2-E",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Neural2-H",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Standard-D",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Standard-F",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Standard-H",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Studio-C",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Wavenet-F",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }, {
      "provider": "google",
      "name": "es-ES-Wavenet-H",
      "styles": ["default"],
      "gender": "female",
      "language": "es-ES"
    }]
  },
  "Spanish - Mexico": {
    "male": [{
      "provider": "microsoft",
      "name": "es-MX-CecilioNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-GerardoNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-JorgeNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-LibertoNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-LucianoNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-PelayoNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-YagoNeural",
      "styles": ["default"],
      "gender": "male",
      "language": "es-MX"
    }, {
      "provider": "amazon",
      "name": "Andrés",
      "styles": ["default"],
      "gender": "male",
      "language": "es-MX"
    }],
    "female": [{
      "provider": "amazon",
      "name": "Mia",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-BeatrizNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-CandelaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-CarlotaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-DaliaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-LarissaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-MarinaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-NuriaNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-MX"
    }, {
      "provider": "microsoft",
      "name": "es-MX-RenataNeural",
      "styles": ["default"],
      "gender": "female",
      "language": "es-MX"
    }]
  },
  "Spanish - US": {
    "male": [{
      "provider": "google",
      "name": "es-US-Studio-B",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Wavenet-C",
      "styles": ["default"],
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Studio-B",
      "styles": ["default"],
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp-HD-D",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Neural2-B",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Neural2-C",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-News-D",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-News-E",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Polyglot-1",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Standard-C",
      "styles": ["default"],
      "gender": "male",
      "language": "es-US"
    }],
    "female": [{
      "provider": "google",
      "name": "es-US-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "amazon",
      "name": "Lupe",
      "styles": ["default"],
      "ntts": true,
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp-HD-F",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp-HD-O",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Neural2-A",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-News-F",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-News-G",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }, {
      "provider": "google",
      "name": "es-US-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "es-US"
    }]
  },
  "Swedish": {
    "male": [{
      "provider": "google",
      "name": "sv-SE-Wavenet-C",
      "styles": ["default"],
      "gender": "male",
      "language": "sv-SE"
    }, {
      "provider": "google",
      "name": "sv-SE-Wavenet-E",
      "styles": ["default"],
      "gender": "male",
      "language": "sv-SE"
    }, {
      "provider": "google",
      "name": "sv-SE-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "sv-SE"
    }, {
      "provider": "google",
      "name": "sv-SE-Standard-E",
      "styles": ["default"],
      "gender": "male",
      "language": "sv-SE"
    }, {
      "provider": "google",
      "name": "sv-SE-Standard-G",
      "styles": ["default"],
      "gender": "male",
      "language": "sv-SE"
    }, {
      "provider": "google",
      "name": "sv-SE-Wavenet-G",
      "styles": ["default"],
      "gender": "male",
      "language": "sv-SE"
    }],
    "female": [{
      "provider": "google",
      "name": "sv-SE-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "sv-SE"
    }, {
      "provider": "google",
      "name": "sv-SE-Wavenet-B",
      "styles": ["default"],
      "gender": "female",
      "language": "sv-SE"
    }, {
      "provider": "google",
      "name": "sv-SE-Wavenet-D",
      "styles": ["default"],
      "gender": "female",
      "language": "sv-SE"
    }, {
      "provider": "amazon",
      "name": "Elin",
      "styles": ["default"],
      "gender": "female",
      "language": "sv-SE"
    }, {
      "provider": "google",
      "name": "sv-SE-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "sv-SE"
    }, {
      "provider": "google",
      "name": "sv-SE-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "sv-SE"
    }, {
      "provider": "google",
      "name": "sv-SE-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "sv-SE"
    }, {
      "provider": "google",
      "name": "sv-SE-Standard-F",
      "styles": ["default"],
      "gender": "female",
      "language": "sv-SE"
    }, {
      "provider": "google",
      "name": "sv-SE-Wavenet-F",
      "styles": ["default"],
      "gender": "female",
      "language": "sv-SE"
    }]
  },
  "Tamil": {
    "male": [{
      "provider": "google",
      "name": "ta-IN-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "ta-IN"
    }],
    "female": [{
      "provider": "google",
      "name": "ta-IN-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }, {
      "provider": "google",
      "name": "ta-IN-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "ta-IN"
    }]
  },
  "Turkish": {
    "male": [{
      "provider": "google",
      "name": "tr-TR-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Wavenet-E",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Standard-E",
      "styles": ["default"],
      "gender": "male",
      "language": "tr-TR"
    }],
    "female": [{
      "provider": "google",
      "name": "tr-TR-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Wavenet-D",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }, {
      "provider": "google",
      "name": "tr-TR-Standard-D",
      "styles": ["default"],
      "gender": "female",
      "language": "tr-TR"
    }]
  },
  "Ukrainian": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "uk-UA-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Wavenet-B",
      "styles": ["default"],
      "gender": "female",
      "language": "uk-UA"
    }]
  },
  "Vietnamese": {
    "male": [{
      "provider": "google",
      "name": "vi-VN-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Charon",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Fenrir",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Orus",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Puck",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Neural2-D",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "vi-VN"
    }],
    "female": [{
      "provider": "google",
      "name": "vi-VN-Wavenet-A",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Achernar",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Aoede",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Autonoe",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Callirrhoe",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Despina",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Erinome",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Gacrux",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Kore",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Laomedeia",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Leda",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Pulcherrima",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Sulafat",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Vindemiatrix",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Chirp3-HD-Zephyr",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Neural2-A",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }, {
      "provider": "google",
      "name": "vi-VN-Standard-C",
      "styles": ["default"],
      "gender": "female",
      "language": "vi-VN"
    }]
  },
  "Language-af-ZA": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "af-ZA-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "af-ZA"
    }]
  },
  "Language-am-ET": {
    "male": [{
      "provider": "google",
      "name": "am-ET-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "am-ET"
    }],
    "female": []
  },
  "Language-bg-BG": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "bg-BG-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "bg-BG"
    }, {
      "provider": "google",
      "name": "bg-BG-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "bg-BG"
    }]
  },
  "Language-et-EE": {
    "male": [{
      "provider": "google",
      "name": "et-EE-Standard-A",
      "styles": ["default"],
      "gender": "male",
      "language": "et-EE"
    }],
    "female": []
  },
  "Language-eu-ES": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "eu-ES-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "eu-ES"
    }, {
      "provider": "google",
      "name": "eu-ES-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "eu-ES"
    }]
  },
  "Language-gl-ES": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "gl-ES-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "gl-ES"
    }, {
      "provider": "google",
      "name": "gl-ES-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "gl-ES"
    }]
  },
  "Language-he-IL": {
    "male": [{
      "provider": "google",
      "name": "he-IL-Wavenet-D",
      "styles": ["default"],
      "gender": "male",
      "language": "he-IL"
    }],
    "female": []
  },
  "Language-is-IS": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "is-IS-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "is-IS"
    }, {
      "provider": "google",
      "name": "is-IS-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "is-IS"
    }]
  },
  "Language-lt-LT": {
    "male": [{
      "provider": "google",
      "name": "lt-LT-Standard-A",
      "styles": ["default"],
      "gender": "male",
      "language": "lt-LT"
    }, {
      "provider": "google",
      "name": "lt-LT-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "lt-LT"
    }],
    "female": []
  },
  "Language-lv-LV": {
    "male": [{
      "provider": "google",
      "name": "lv-LV-Standard-A",
      "styles": ["default"],
      "gender": "male",
      "language": "lv-LV"
    }, {
      "provider": "google",
      "name": "lv-LV-Standard-B",
      "styles": ["default"],
      "gender": "male",
      "language": "lv-LV"
    }],
    "female": []
  },
  "Language-mr-IN": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "mr-IN-Wavenet-C",
      "styles": ["default"],
      "gender": "female",
      "language": "mr-IN"
    }]
  },
  "Language-sr-RS": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "sr-RS-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "sr-RS"
    }, {
      "provider": "google",
      "name": "sr-RS-Standard-B",
      "styles": ["default"],
      "gender": "female",
      "language": "sr-RS"
    }]
  },
  "Language-sw-KE": {
    "male": [{
      "provider": "google",
      "name": "sw-KE-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "sw-KE"
    }],
    "female": []
  },
  "Language-te-IN": {
    "male": [{
      "provider": "google",
      "name": "te-IN-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "te-IN"
    }],
    "female": []
  },
  "Language-th-TH": {
    "male": [],
    "female": [{
      "provider": "google",
      "name": "th-TH-Neural2-C",
      "styles": ["default"],
      "gender": "female",
      "language": "th-TH"
    }, {
      "provider": "google",
      "name": "th-TH-Standard-A",
      "styles": ["default"],
      "gender": "female",
      "language": "th-TH"
    }]
  },
  "Language-uk-UA": {
    "male": [{
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Achird",
      "styles": ["default"],
      "gender": "male",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Algenib",
      "styles": ["default"],
      "gender": "male",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Algieba",
      "styles": ["default"],
      "gender": "male",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Alnilam",
      "styles": ["default"],
      "gender": "male",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Enceladus",
      "styles": ["default"],
      "gender": "male",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Iapetus",
      "styles": ["default"],
      "gender": "male",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Rasalgethi",
      "styles": ["default"],
      "gender": "male",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Sadachbia",
      "styles": ["default"],
      "gender": "male",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Sadaltager",
      "styles": ["default"],
      "gender": "male",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Schedar",
      "styles": ["default"],
      "gender": "male",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Umbriel",
      "styles": ["default"],
      "gender": "male",
      "language": "uk-UA"
    }, {
      "provider": "google",
      "name": "uk-UA-Chirp3-HD-Zubenelgenubi",
      "styles": ["default"],
      "gender": "male",
      "language": "uk-UA"
    }],
    "female": []
  },
  "Language-ur-IN": {
    "male": [{
      "provider": "google",
      "name": "ur-IN-Wavenet-B",
      "styles": ["default"],
      "gender": "male",
      "language": "ur-IN"
    }],
    "female": []
  },
  "Language-yue-HK": {
    "male": [{
      "provider": "google",
      "name": "yue-HK-Standard-D",
      "styles": ["default"],
      "gender": "male",
      "language": "yue-HK"
    }],
    "female": []
  }
};